@import "../../variables.scss";

.editWorkType {
  &__title {
    margin: 2rem 1rem 0.5rem;
    font-size: 2rem;
    letter-spacing: 0.6px;
    @media (max-width: $size-sm) {
      font-size: 1.5rem;
    }
  }
  &__card {
    box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.25);
    border-radius: 4px;
    background: white;
    padding: 0.1rem 1.5rem 0;
    margin: 1rem 1rem 3rem;

    h3 {
      font-size: 1rem;
      letter-spacing: 0.6px;
      font-weight: normal;
    }
  }
  &__button {
    &:hover {
      color: white !important;
    }
  }
}
